import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

function fmtErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function ChangePasswordForm({ forced = false, onDone }) {
  const { changePassword } = useAuth();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (np.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    if (np !== cp) { toast.error("New password and confirmation do not match."); return; }
    setLoading(true);
    try {
      await changePassword({ current_password: cur, new_password: np, confirm_password: cp });
      toast.success("Password updated. You're all set.");
      setCur(""); setNp(""); setCp("");
      onDone && onDone();
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const Input = ({ label, value, onChange, testid }) => (
    <div className="mb-3">
      <label className="text-xs text-[#94A3B8]">{label}</label>
      <input type="password" value={value} onChange={(e) => onChange(e.target.value)} required data-testid={testid}
        className="w-full mt-1 px-4 py-3 rounded-lg bg-[#0A0C10] border border-[#2A3042] outline-none focus:border-[#D4AF37] text-[#F8FAFC] text-base" />
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="change-password-form">
      {forced && (
        <div className="flex items-start gap-2 mb-4 p-3 rounded-lg bg-[#F59E0B]/10 border border-[#F59E0B]/30">
          <ShieldCheck className="w-5 h-5 text-[#F59E0B] mt-0.5" />
          <div className="text-sm text-[#F8FAFC]">Your temporary password needs to be changed before you continue. Choose a new private password.</div>
        </div>
      )}
      <Input label="Current password" value={cur} onChange={setCur} testid="cp-current" />
      <Input label="New password (min 8 characters)" value={np} onChange={setNp} testid="cp-new" />
      <Input label="Confirm new password" value={cp} onChange={setCp} testid="cp-confirm" />
      <button type="submit" disabled={loading} data-testid="cp-submit"
        className="gold-btn w-full py-3 rounded-lg inline-flex items-center justify-center gap-2 disabled:opacity-60">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Update password
      </button>
    </form>
  );
}
